import React from 'react';
import styled from '@benzinga/themetron';
import Script from 'next/script';

export interface InstagramBlockProps {
  tag: 'blockquote';
  tagAttributes: {
    className: 'instagram-media';
    'data-instgrm-captioned': string;
    'data-instgrm-permalink': string;
    'data-instgrm-version': string;
    style: string;
  };
  innerHTML: string;
  url?: string;
}

export const InstagramBlock: React.FC<InstagramBlockProps> = ({ innerHTML, tagAttributes, url }) => {
  const instagramUrl = url || tagAttributes?.['data-instgrm-permalink'];

  if (!instagramUrl) return null;

  const urlObject = new URL(instagramUrl);
  urlObject.searchParams.set('utm_source', 'ig_embed');
  urlObject.searchParams.set('utm_campaign', 'loading');

  return (
    <Container className="instagram-block">
      <blockquote
        className="instagram-media"
        dangerouslySetInnerHTML={{ __html: innerHTML || '<div></div>' }}
        data-instgrm-captioned
        data-instgrm-permalink={urlObject.href}
        data-instgrm-version={tagAttributes?.['data-instgrm-permalink'] || '14'}
      />
      <Script async={true} src="//www.instagram.com/embed.js" />
    </Container>
  );
};

export const Container = styled.div`
  &.instagram-block {
    margin: 1rem 0;
    display: flex;
    align-items: center;
    justify-content: center;

    blockquote {
      background: #fff;
      border: 0;
      border-radius: 3px;
      box-shadow:
        0 0 1px 0 rgba(0, 0, 0, 0.5),
        0 1px 10px 0 rgba(0, 0, 0, 0.15);
      margin: 1px;
      padding: 0;
      max-width: 540px;
      min-width: 326px;
      width: -webkit-calc(100% - 2px);
      width: calc(100% - 2px);
    }

    iframe {
      margin-bottom: 0 !important;
    }
  }
`;

export default InstagramBlock;
